/**
 * VENDOR MODULES
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

import GridOdd from 'shared/components/outcomes/grids/GridOdd';
import { vsOutcomeTypeKey } from 'lib/virtualSportsI18n';

/**
 * Renders the lists of number of pitches
 *
 * @class  NumberOfPitches (name)
 * @param  {<type>}   props The properties
 * @return {boolean}  { description_of_the_return_value }
 */
function NumberOfPitches(props) {
  const { t } = useTranslation();
  const {
    outcomes,
  } = props

  const number_of_pitches = Object.values(outcomes)
    .filter(x => parseInt(x.market_type_id) === 4002)
    .slice()
    .sort((a, b) => Number(a.outcome_type_id) - Number(b.outcome_type_id));

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 p-3">
      {number_of_pitches.map((outcome) => (
        <GridOdd
          key={outcome.outcome_id}
          {...{
            ...outcome,
            class_names: ['grid-odd-baseball', 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
            market_type_group_id: 402,
            display_label: t(vsOutcomeTypeKey(outcome.outcome_type_id, false)),
          }}
        />
      ))}
    </div>
  );
}

export default NumberOfPitches;

